// removed by extract-text-webpack-plugin
module.exports = {"CourseRoomsContainer":"courseRooms__CourseRoomsContainer__2btjr","CreateRoom":"courseRooms__CreateRoom__1mM-U","Filters":"courseRooms__Filters__2J-Ue","InfoBoxContainer":"courseRooms__InfoBoxContainer__3xi7n","InfoBoxFilters":"courseRooms__InfoBoxFilters__B-JRL","FilterOpts":"courseRooms__FilterOpts__3FpW-","SortUI":"courseRooms__SortUI__cfUbZ","RoomsListContainer":"courseRooms__RoomsListContainer__3xwAr","CustomIcon":"courseRooms__CustomIcon__1HrRg","SelectActionsIcon":"courseRooms__SelectActionsIcon__2jsI8"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/CourseRooms/courseRooms.css
// module id = 1703
// module chunks = 2